export default __webpack_public_path__ + "static/media/download_logo.3b3335c6.png";